import classNames from "classnames/bind";
import { RadioButton as Radio } from "primereact/radiobutton";
import {
  Control,
  Controller,
  FieldValues,
  Path,
  RegisterOptions,
} from "react-hook-form";
import classes from "./RadioButton.module.scss";

type RadioButtonProps<TData extends FieldValues> = {
  control: Control<TData>;
  name: Path<TData>;
  value: string;
  rules?: RegisterOptions;
  errorMessage?: string | boolean;
  label?: string;
  disabled?: boolean;
  readOnly?: boolean;
  labelPosition?: "right" | "left";
};

const RadioButton = <TData extends FieldValues>({
  control,
  name,
  rules,
  errorMessage,
  label,
  disabled = false,
  readOnly,
  value,
  labelPosition = "right",
}: RadioButtonProps<TData>): React.ReactElement => {
  const cx = classNames.bind(classes);

  return (
    <div className={cx(classes.radioButtonWrapper)}>
      {labelPosition === "left" ? (
        <label
          htmlFor={value}
          className={cx({
            radioError: errorMessage,
          })}
        >
          {label}
        </label>
      ) : null}
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({
          field: { value: rhfValue, onChange },
          fieldState: { error },
        }) => (
          <Radio
            readOnly={readOnly}
            disabled={disabled}
            checked={value === rhfValue}
            inputId={value}
            value={value}
            onChange={onChange}
            className={classNames({
              "p-invalid": error,
              [classes.readOnly]: readOnly,
            })}
          />
        )}
      />
      {labelPosition === "right" ? (
        <label
          htmlFor={value}
          className={cx({
            radioError: errorMessage,
          })}
        >
          {label}
        </label>
      ) : null}
      <div className={cx(classes.errorContainer)}>
        {typeof errorMessage === "string" ? (
          <small className="p-error">{errorMessage}</small>
        ) : null}
      </div>
    </div>
  );
};

export default RadioButton;
